import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import StableMuiDialog from '../../../../common/StableMuiDialog.js';
import { useOfferOptionsStore } from '../../Offers/offerOptionsStore.js';
import {
  CANCEL_BUTTON_SX,
  DIALOG_PAPER_SX,
  MethodCard,
  OptionsPanel,
  PRIMARY_BUTTON_SX,
  SectionLabel,
  colors,
} from '../../Offers/TownPortalFlow/TownPortalOffersDialog.js';

export default function SpreadsheetDownloadDialog({ open, onClose, onConfirm }) {
  const [sheetKind, setSheetKind] = useState('internal');
  const [includeComps, setIncludeComps] = useState(true);

  useEffect(() => {
    if (!open) return;
    setSheetKind('internal');
    setIncludeComps(useOfferOptionsStore.getState().includeCompsInOffersSpreadsheet !== false);
  }, [open]);

  return (
    <StableMuiDialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { ...DIALOG_PAPER_SX, maxWidth: 460 } }}
    >
      <Box sx={{ p: 3 }}>
        <Typography component="h2" sx={{ fontSize: 17, fontWeight: 500, color: colors.textPrimary, m: '0 0 4px' }}>
          Download spreadsheet
        </Typography>
        <Typography sx={{ fontSize: 13, color: colors.textSecondary, m: '0 0 20px' }}>
          Choose which version to download
        </Typography>
        <SectionLabel>Spreadsheet</SectionLabel>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2.5 }}>
          <MethodCard
            active={sheetKind === 'internal'}
            icon={<GridOnOutlinedIcon fontSize="inherit" />}
            name="Internal"
            description="Case review sheet"
            onClick={() => setSheetKind('internal')}
          />
          <MethodCard
            active={sheetKind === 'external'}
            icon={<TableChartOutlinedIcon fontSize="inherit" />}
            name="External"
            description="Offers sheet sent to the town"
            onClick={() => setSheetKind('external')}
          />
        </Box>
        {sheetKind === 'external' && (
          <>
            <SectionLabel>Spreadsheet options</SectionLabel>
            <OptionsPanel visible>
              <FormControlLabel
                sx={{ display: 'flex', mx: 0, alignItems: 'flex-start', '& .MuiFormControlLabel-label': { fontSize: 13, pt: '2px' } }}
                control={
                  <Checkbox
                    size="small"
                    checked={includeComps}
                    onChange={(e) => setIncludeComps(e.target.checked)}
                    sx={{ py: 0 }}
                  />
                }
                label="Include comp addresses and workup value columns in spreadsheet"
              />
            </OptionsPanel>
          </>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, pt: 0.5 }}>
          <Button onClick={onClose} sx={CANCEL_BUTTON_SX}>Cancel</Button>
          <Button
            onClick={() => onConfirm({ external: sheetKind === 'external', includeComps })}
            variant="contained"
            disableElevation
            sx={PRIMARY_BUTTON_SX}
          >
            Download
          </Button>
        </Box>
      </Box>
    </StableMuiDialog>
  );
}
